export const UPDATE_APP = "UPDATE_APP";
export const UPDATE_RANGE = "UPDATE_RANGE";
export const CLEAR_FILTER = "CLEAR_FILTER";
